"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
/**
 * Event bus:
 *
 * Publish-subscribe event bus. Responsibilities:
 * - providing possibility of subscribing to particular topics
 * - providing possibility of publishing events to particular topics
 */
var EventBus = /** @class */ (function () {
    function EventBus() {
        this.topics = {};
        this.externalSubscribers = {};
        this.que = [];
    }
    EventBus.prototype.subscribe = function (topic, callback) {
        if (!this.topics[topic]) {
            this.topics[topic] = [];
        }
        this.topics[topic].push(callback);
    };
    EventBus.prototype.publish = function (topic, args) {
        this.que.push({
            topic: topic,
            args: args,
        });
        if (this.que.length > 1) {
            return;
        }
        var _loop_1 = function () {
            var q = this_1.que[0];
            var all = __spreadArrays((this_1.topics[q.topic] || []), (this_1.externalSubscribers[q.topic] || []));
            all.forEach(function (callback) { return callback(q.args); });
            this_1.que.shift();
        };
        var this_1 = this;
        while (this.que.length > 0) {
            _loop_1();
        }
    };
    EventBus.prototype.on = function (topic, callback) {
        var _this = this;
        if (!this.externalSubscribers[topic]) {
            this.externalSubscribers[topic] = [];
        }
        this.externalSubscribers[topic].push(callback);
        return function () { return _this.off(topic, callback); };
    };
    EventBus.prototype.off = function (topic, callback) {
        if (!this.externalSubscribers[topic]) {
            return;
        }
        this.externalSubscribers[topic] = this.externalSubscribers[topic].filter(function (existingCallback) { return existingCallback !== callback; });
    };
    return EventBus;
}());
exports.EventBus = EventBus;
